import { ButtonSize, IconButton } from '@ardoq/button';
import { IconName } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { t, type I18nLocale } from '@ardoq/i18n';
import { ArdoqLoaderSpinner, LoaderSize } from '@ardoq/loader';
import { colors } from '@ardoq/design-tokens';
import { DocumentItemViewModel } from '../assistantDocumentsOperations';
import { DocumentPreview } from './DocumentPreview';

type DocumentChipProps = {
  item: DocumentItemViewModel;
  i18nLocale: I18nLocale;
  onRemove: VoidFunction;
};

export const DocumentChip = ({
  item,
  i18nLocale,
  onRemove,
}: DocumentChipProps) => (
  <FlexBox
    align="center"
    gap="xsmall"
    paddingX="small"
    paddingY="xxsmall"
    borderColor="borderSubtle"
    borderWidth={1}
    borderRadius="r8"
  >
    <DocumentPreview item={item} />
    {item.isUploading ? (
      <FlexBox
        align="center"
        justify="center"
        aria-label={t(
          i18nLocale,
          'assistant:documents.uploading',
          { name: item.name },
          'Uploading {{name}}'
        )}
      >
        <ArdoqLoaderSpinner size={LoaderSize.SMALL} color={colors.iconBrand} />
      </FlexBox>
    ) : (
      <IconButton
        buttonSize={ButtonSize.SMALL}
        iconName={IconName.CLOSE}
        onClick={onRemove}
        label={t(
          i18nLocale,
          'assistant:documents.removeDocument',
          'Remove document'
        )}
        i18nLocale={i18nLocale}
      />
    )}
  </FlexBox>
);
